import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { useTokensQuery } from '@modules/tokens/queries';

import type { IAppConfigResponse } from '../types';
import {
  CONFIG_API_URL,
  CONFIG_QUERY_KEY,
} from '../constants';

export default function useConfigQuery(): IContextQueryResult<IAppConfigResponse, Error> {
  const { isSuccess: enabled } = useTokensQuery();
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [CONFIG_QUERY_KEY],
    refetchOnMount: false,
    gcTime: Infinity,
    staleTime: Infinity,
    queryFn: ({ signal }) => fetchGet<IAppConfigResponse>(CONFIG_API_URL, {
      signal,
      isEssential: true,
    }),
    enabled,
  });
}
